import { App } from "@lib/titan2/dist/game/App";
import { FactoryManager } from "@lib/titan2/dist/game/factory/FactoryManager";
import { FontManager } from "@lib/titan2/dist/game/manager/FontManager";
import { LanguageManager } from "@lib/titan2/dist/game/manager/LanguageManager";
import { Logger, LogLevel } from "@lib/titan2/dist/util/log/Logger";
import { Factory } from "./common/factory/Factory";
export class FruityFortune {
    constructor(version, loadedHandler) {
        this.register();
        this.loadFonts(version, loadedHandler);
    }
    static getApp() {
        return FruityFortuneApp;
    }
    register() {
        this.factoryManager = FactoryManager.getInstance();
        this.fontManager = FontManager.getInstance();
        this.registerFactory();
        Logger.setLogLevel(LogLevel.VERBOSE);
    }
    registerFactory() {
        let factory = new Factory();
        this.factoryManager.setFactory(factory);
    }
    loadFonts(version, loadedHandler) {
        let cssPath = this.getCSSPath(version);
        this.fontManager.loadWebFonts(version, cssPath, loadedHandler);
    }
    getCSSPath(version) {
        let locale = LanguageManager.getInstance().getLocale();
        /*let id: string = locale.getId();
        if (!locale.useNativeFont()) {
            id = "default";
        }*/
        return [version + "/css/font_" + /*id*/ "default" + ".css", version + "/css/font_common.css"];
    }
}
class FruityFortuneApp extends App {
    createRendererProperties() {
        super.createRendererProperties();
        this.rendererProperties.antialias = true;
    }
}
//# sourceMappingURL=FruityFortune.js.map